import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BadgeIconDirective } from './directives/badge-icon.directive';

@NgModule({
	declarations: [BadgeIconDirective],
	exports: [BadgeIconDirective],
	imports: [
		CommonModule
	]
})
export class BadgeModule { }
